module.exports = __webpack_public_path__ + "img/Breville_side_by_side.6aa1ec87.jpg";